import {CHECK_ZIP_SUCCESS, RESTAURANT_LIST_BY_ZIP_SUCCESS} from 'new-constants/api.constants';
import {DONE_DELIVERY_ADDRESS, DONE_LOGOUT_CONFIRMATION} from 'new-constants/popup.constants';
import {DeliveryAddressState} from './delivery-address.reducer.types';
import {REPEAT_ORDER, REPEAT_ORDER_SUCCESS} from '../constants/api.constants';
import {DONE_DELIVERY_ADDRESS_FROM_CART} from '../constants/popup.constants';

const initialState: DeliveryAddressState = {
	zip: '',
	address: '',
	predictionId: null,
	latitude: null,
	longitude: null,
};

export const deliveryAddressReducer = (previousState = initialState, action): DeliveryAddressState => {
	switch (action && action.type) {
		case DONE_DELIVERY_ADDRESS:
		case DONE_DELIVERY_ADDRESS_FROM_CART:
			return {
				...previousState,
				address: action.address,
				predictionId: action.predictionId,
				latitude: action.location?.latitude,
				longitude: action.location?.longitude,
			};
			break;
		case RESTAURANT_LIST_BY_ZIP_SUCCESS:
			return {
				...previousState,
				zip: action.payload.zip,
			};
			break;
		case DONE_LOGOUT_CONFIRMATION:
			return {
				...previousState,
				zip: '',
				address: '',
				predictionId: null,
				latitude: null,
				longitude: null,
			};
			break;

		case REPEAT_ORDER_SUCCESS:
			return {
				...previousState,
				zip: action.payload.data.zip,
				address: action.payload.data.address,
				predictionId: null,
				latitude: null,
				longitude: null,
			};
			break;
		default:
			return previousState;
	}
};
